export default "__VITE_ASSET__52a4ec30__"